module.exports = __webpack_public_path__ + "static/media/Jin S Yoon.7da6bf00.jpeg";